"use strict";
/**
 * <h4>Generating recommended products</h4>
 *
 * @packageDocumentation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.Filters = exports.FilterApi = exports.Recommendation = exports.RecommendationError = exports.Product = void 0;
var Product_1 = require("./IO/Output/Product");
Object.defineProperty(exports, "Product", { enumerable: true, get: function () { return Product_1.Product; } });
var RecommendationError_1 = require("./IO/Output/Error/RecommendationError");
Object.defineProperty(exports, "RecommendationError", { enumerable: true, get: function () { return RecommendationError_1.RecommendationError; } });
var RecommendationImpl_1 = require("./RecommendationImpl");
Object.defineProperty(exports, "Recommendation", { enumerable: true, get: function () { return RecommendationImpl_1.RecommendationImpl; } });
var FilterApi_1 = require("./FilterApi");
Object.defineProperty(exports, "FilterApi", { enumerable: true, get: function () { return FilterApi_1.FilterApi; } });
/** @module */
exports.Filters = require("./IO/Input/Filters/");
/** @module */
exports.Error = require("./IO/Output/Error/");
// @todo:
// możliwe do przekazania do zgłoszenia o ramkę reko:
// case 'user':                    $qparams['u'] = $value; break;
// case 'user_type':               $qparams['ut'] = $value; break;
// case 'emailIdentity':           $qparams['emailIdentity'] = $value; break;
//# sourceMappingURL=index.js.map